import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { CustomerService } from '../service/CustomerService';
import { Button } from 'primereact/button';
import { useHistory } from "react-router-dom";
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import React, { useEffect, useState } from 'react';

export const MailsLogPage = () => {

    let emptyMailLog = {
        id: null,
        name: '',
        image: null,
        description: '',
        category: null,
        price: 0,
        quantity: 0,
        rating: 0,
        inventoryStatus: 'INSTOCK'
    };
    
    const [mailsLog, setMailsLog] = useState(null);
    const [globalFilter, setGlobalFilter] = useState('');
    const [loading, setLoading] = useState(true);
    const [mailLog, setMailLog] = useState(emptyMailLog);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(100);
    const [deleteMailLogDialog, setDeleteMailLogDialog] = useState(false);
    
    const toast = React.useRef(null);

    let history = useHistory();

    useEffect(() => {        
        const requestPayload = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*' ,
                'Authorization': 'Bearer ' +localStorage.getItem('jwt')
            },
            body: JSON.stringify({
                page: page,
                size: size,
                keyword: ""
            })
        }        
        
        fetch('https://springboot-widy-app.widyan123.site/widy-app/mail/paging', requestPayload)
        .then((res) => {
            console.log('HTTP ', res.status);
            return res.json().then(
              (body) => ({
                httpStatus: res.status,
                body,
              })
            );
          })
          .then(({httpStatus, body}) => {
            if(httpStatus >= 400 && httpStatus <= 599) {
                console.error('Error response:', httpStatus, body);
                return Promise.reject(body);
            } else {
                console.log('Successful response:', body); 
                setMailsLog(body.data);
                setLoading(false);
            }
          })
          .catch((error) => {
            console.error('Request failed:', error);
            setLoading(false);
          });
    }, []);

    const openEdit = (rowData) => {
        history.push({
            pathname: '/mail-log',
            state: {
                todo: 'Ubah',
                dataMailLog: rowData
            }
        });
    }

    const confirmDeleteMailLog = (mailLog) => {
        setMailLog(mailLog);
        setDeleteMailLogDialog(true);        
    }

    async function deleteMailLogBackEnd(mailLog) {
        const requestPayload = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*' ,
                'Authorization': 'Bearer ' +localStorage.getItem('jwt')
            }

        }         
          
        const response = await fetch(`https://springboot-widy-app.widyan123.site/widy-app/mail/delete/${mailLog.id}`, requestPayload);        
        const res = await response.json();
        console.log('response', res);
        if(response.status >= 200 && response.status <= 299) {
            toast.current.show({ severity: 'success', summary: 'Successful', detail: res.message, life: 3000 });
        } else if(response.status >= 400 && response.status <= 499) {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: res.message, life: 3000 });
        } else {
            toast.current.show({ severity: 'error', summary: 'Error', detail: res.message, life: 3000 });
        }
    }

    const roleTableHeader = (
        <div className="table-header">
            List of Mail Log
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
            </span>
        </div>
    );

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    const createdAtBodyTemplate = (rowData) => {
        const date = new Date(rowData.createdAt);
        const createdAt = dateFormat(date);
        return (
            <>
            <span className='p-column-title'>Created At</span>
            {createdAt}
            </>
        )
    }

    function dateFormat(date) {
        return  [
                    date.getDate() < 10 ? '0'+date.getDate():date.getDate(), 
                    date.getMonth()+1 < 10 ? '0'+Math.round(date.getMonth()+1):date.getMonth()+1, 
                    date.getFullYear()
                ]
                .join('/')+' '+
                [
                    date.getHours() < 10 ? '0'+date.getHours():date.getHours(), 
                    date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes()
                ]
                .join(':');

    }

    const statusBodyTemplate = (rowData) => {
        return (
            <>
            <span className='p-column-title'>Status</span>
            {rowData.status === 1 ? 'Sent':'Failed'}
            </>
        )
    }

    const typeBodyTemplate = (rowData) => {
        return (
            <>
            <span className='p-column-title'>Type</span>
            {rowData.type === 1 ? 'Text':'Template'}
            </>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => openEdit(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => confirmDeleteMailLog(rowData)} />
            </div>
        );
    }

    const hideDeleteMailLogDialog = () => {
        setDeleteMailLogDialog(false);
    }

    const deleteMailLog = () => {
        let _mailsLog = mailsLog.filter(val => val.id !== mailLog.id);
        setMailsLog(_mailsLog);
        setDeleteMailLogDialog(false);
        setMailLog(emptyMailLog);        
        deleteMailLogBackEnd(mailLog); 

    }

    const deleteMailLogDialogFooter = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteMailLogDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteMailLog} />
        </>
    );

    return (
        <div className="grid table-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <DataTable value={mailsLog} paginator className="p-datatable-customers" rows={7} dataKey="id" rowHover
                        globalFilter={globalFilter} emptyMessage="No Mail found." loading={loading} header={roleTableHeader}>
                        <Column field="subject" header="Subject" sortable body={bodyTemplate}></Column>
                        <Column field="receiver" header="Receiver" sortable body={bodyTemplate}></Column>
                        <Column field="createdAt" header="Created At" sortable body={createdAtBodyTemplate}></Column>
                        <Column field="status" header="Status" sortable body={statusBodyTemplate}></Column>
                        <Column field="type" header="Type" sortable body={typeBodyTemplate}></Column>
                        <Column header="Action" body={actionBodyTemplate}></Column>
                    </DataTable>

                    <Dialog visible={deleteMailLogDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteMailLogDialogFooter} onHide={hideDeleteMailLogDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {mailLog && <span>Are you sure you want to delete <b>{mailLog.subject}</b>?</span>}
                        </div>
                    </Dialog>
                </div>
            </div>
        </div>
    )
}
